<template>
    <div class="demoPage">
        <!-- tab切换 -->
        <div class="navTabs fixed-content">
            <div class="tabs" @click="toPage('/studentRoomManger')">整体情况</div>
            <div class="tabs border-bottom-03a9f4 color-appStyle">楼栋情况</div>
            <div class="tabs" @click="toPage('/studentRoomMangerTwo')">学院分布表</div>
        </div>

        <div class="tabContent scroll-content">
            <div class="grid" style="padding: 0; margin-top: 10px;">
            <div class="gridWarp bg-appStyle color-fff">
                <div class="gridCell flex-1 bold">楼栋</div>
                <div class="gridCell flex-1 bold">房间总数</div>
                <div class="gridCell flex-1 bold">已入住</div>
                <div class="gridCell flex-1 bold">空置房</div>
                <div class="gridCell flex-1 bold">破损房</div>
                <div class="gridCell flex-1 bold">入住率</div>
            </div>

            <div v-if="dormAreaList.length > 0">
              <div class="gridWarp bg-fff" v-for="(item, index) in dormAreaList" :key="index">
                <div class="gridCell flex-1" :class="{'bold': item.zoneName == '总计'}">{{item.zoneName}}</div>
                <div class="gridCell flex-1">{{item.allCnt}}</div>
                <div class="gridCell flex-1">{{item.yrzCnt}}</div>
                <div class="gridCell flex-1">{{item.kzfCnt}}</div>
                <div class="gridCell flex-1">{{item.psfCnt}}</div>
                <div class="gridCell flex-1">{{item.rzblStr}}</div>
              </div>
            </div>

            </div>
        </div>
    </div>
</template>

<script>
import service from "@/fetch/service";
export default {
    data () {
        return {
            dormAreaList: []
        }
    },
    created() {
        this.getDatas()
    },
    methods: {
        toPage: function(pageName) {
            this.$router.replace(pageName);
        },
        getDatas: function () {
            service
            .findLdDetail({})
            .then(res => {
                console.log(res)
                if (res.success) {
                this.dormAreaList = res.result
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    $fixed-height: px2rem(80px);
    .fixed-content {
        height: calc(#{$fixed-height}) !important;
    }
    .scroll-content {
        top: calc(#{$fixed-height}) !important;
    }
</style>



// WEBPACK FOOTER //
// FloorSituation.vue?a28b669c